import { Text, View } from "@react-pdf/renderer";
import Column from "./column";

function TrailerSchedule({ trailersData }) {
  /*   tVinList,
  tYearList,
  tMakeModelList,
  tBodyTypeList,
  tDeductibleList,
  tLossPayeeList, */
  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 30,
        width: "100%",
      }}
    >
      <Text style={{ fontWeight: 600, fontSize: 30 }}>Trailer Schedule</Text>
      {trailersData.tVinList.length !== 0 ? (
        <>
          <Text
            style={{
              fontWeight: 600,
              fontSize: 18,
              marginTop: 15,
              textAlign: "center",
            }}
          >
            It is hereby noted and agreed that only the vehicle(s) specified in
            the schedule are covered:
          </Text>
          <View
            style={{
              maxWidth: 700,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              marginTop: 20,
            }}
          >
            <View
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                border: "1.5px solid black",
                marginLeft: 10,
                marginRight: 10,
              }}
            >
              <Column columnName="VIN" items={trailersData.tVinList} />
              <Column columnName="Year" items={trailersData.tYearList} />
              <Column
                columnName="Make/Model"
                items={trailersData.tMakeModelList}
              />
              <Column
                columnName="Body Type"
                items={trailersData.tBodyTypeList}
              />
              <Column
                columnName="Loss Payee"
                items={trailersData.tLossPayeeList}
              />
              <Column columnName="APD Limit" items={["$50,000"]} />
              <Column
                columnName="APD Deductible"
                items={trailersData.tDeductibleList}
              />
            </View>
          </View>
        </>
      ) : (
        <>
          <Text style={{ fontWeight: 600, fontSize: 18, marginTop: 15 }}>
            Trailers are Excluded and{" "}
            <Text style={{ textDecoration: "underline" }}>not covered</Text>{" "}
            under this Policy
          </Text>
        </>
      )}
    </View>
  );
}
export default TrailerSchedule;
